(function($) {
  $.fn.pillButtons = function(config) {
    var opts = $.extend({}, $.fn.pillButtons.defaults, config);
    this.each(function() {
      var $container = $(this);

      $container.find('a').on('click', function(event) {
        event.preventDefault();
        var $this = $(this);
        if (opts.hasClickHandler($this)) {
          return;
        }

        if (!opts.multiState) {
          $container.find('li a.' + opts.activeClass).removeClass('active');
          $this.addClass('active');
        } else {
          $this.toggleClass('active');
        }
      });
      if (!$.isBlank(opts.defaultSelector)) {
        $container.find(opts.defaultSelector).addClass(opts.activeClass);
      }
    });
  };

  $.fn.pillButtons.defaults = {
    activeClass: 'active',
    defaultSelector: 'li:first-child a',
    hasClickHandler: function() {
      return false;
    },
    multiState: false
  };
})(jQuery);
